import { defineComponent as _defineComponent } from 'vue'
import { ref, watchEffect } from 'vue';
import { useGlobalBi } from '../../hooks/use-global-bi';
import CouponDetail from './detail-module/index.vue';
import { useCouponDetail } from './detail-module/hooks/use-coupon-detail';
import { UrlParamKey, getUrlParamByKey } from '@/utils/url-params-helper';
import { jumpPage } from '@tencent/wphk-components-jump-page';
import { biClick } from '@tencent/fit-bi-sdk';
import { handleCouponShareSetInfo } from '@tencent/wphk-components-wecoupon/components/share-channel';
import { i18n } from '@/i18n';



export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isLoadFinished = ref(false);
const { getBiExt } = useGlobalBi();
const { initCouponDetail, couponInfo } = useCouponDetail();

const couponId = ref('');
couponId.value = getUrlParamByKey(UrlParamKey.couponId);
// 券详情查询
initCouponDetail(couponId.value);

watchEffect(() => {
  if (couponInfo.value) {
    isLoadFinished.value = true;
    // 设置分享信息
    const { couponId, couponName } = couponInfo.value;
    const { spId, spLogo, spName } = couponInfo.value.merchantInfo;
    handleCouponShareSetInfo({
      couponName,
      couponId,
      spId,
      spLogo,
      spName,

      adtagPrefix: 'coupon',
    });
  }
});

function  handleGoWecoupon() {
  biClick('coupon-detail.gowecouon-banner-click|点击跳转派券平台banner', {
    fspid: getBiExt().fspid,
  });
  jumpPage.goWeCoupons({
    adtag: 'sharecoupon',
  });
}

return { __sfc: true,isLoadFinished, getBiExt, initCouponDetail, couponInfo, couponId, handleGoWecoupon, CouponDetail, i18n }
}

})